import { Close as Close_kojaro } from './Close.kojaro';
import { Close as Close_phosphor } from './Close.phosphor';
import { Close as Close_zoomg } from './Close.zoomg';
import { Close as Close_zoomit } from './Close.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Close_kojaro;

    case 'zoomg':
      return Close_zoomg;

    case 'phosphor':
      return Close_phosphor;

    default:
      return Close_zoomit;
  }
};

export const Close = IconRenderer();
